import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { ontarioOrConfig } from "./data";

export default function OntarioOrPage() {
  return <OregonCityPageTemplate config={ontarioOrConfig} />;
}